import './rating_badge.less';

import { Star as StarIcon } from 'react-feather';
import classnames           from 'classnames';
import React                from 'react';

import FacebookIcon         from './facebook_logo.svg';
import GoogleIcon           from './google_logo.svg';
import NextDoorIcon         from './nextdoor_logo.svg';
import TripAdvisorIcon      from './trip_advisor_logo.svg';
import YelpIcon             from './yelp_logo.svg';


const platformIcons = {
  facebook:    FacebookIcon,
  google:      GoogleIcon,
  nextdoor:    NextDoorIcon,
  tripAdvisor: TripAdvisorIcon,
  yelp:        YelpIcon
};

export default function RatingBadge({ platform, rating }) {
  const Icon = platformIcons[platform];
  if (!Icon)
    return null;

  const classNames = classnames('rating-badge', platform, `rating-${rating}`);
  return (
    <div className={classNames}>
      <div className="platform-icon">
        <Icon/>
      </div>
      <div className="rating-star">
        <div className="rating">{rating}</div>
        <StarIcon className="star-icon"/>
      </div>
    </div>
  );
}
